import parseExpression from "./expression-parser";

export default {
    parseExpression
}
